export class ListCatalogsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogs",
            "baseName": "catalogs",
            "type": "Array<Catalog>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCatalogsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
